import { COOKIE_NAME_EMAIL_SIGNUP_MARKETING_OPTIN, COOKIE_INTERSTITIAL_DEFERRED } from '../constants';
import { getUniqueVisitsFromCookie, clearUniqueVisitsCookie, clearInterstitialDeferredCookie } from '../utils/cookieUtils';
import Cookies from '../services/cookies';
import { generate } from '../../../core/js/utils/componentUtils';
import { isWebview } from '../../../core/js/utils/cookieUtils';
import { emailSignupMarketingSaga } from '../sagas/userSagas';

/**
 * Return true if current path is in the excluded routes list
 * @param {object} store Redux store
 * @returns {boolean} whether current path is in exclude list
 */
function isExcludedEmailSignupRoute(store) {
    return !!_.find(
        _.get(store.getState(), 'core.constants.emailSignupModalExcludedRoutes', []),
        _.partial(_.includes, window.location.pathname)
    );
}

/**
 * Noop if user has opt in cookie set
 * If user is on page visit past their first, run email signup saga and set
 * opt in cookie to true
 * @param {object} store Redux store
 */
function setEmailSignupMarketingCookie(store) {
    // Has interstitial been deferred?
    const interstitialDiffered = Cookies.getCookieByName(COOKIE_INTERSTITIAL_DEFERRED) || false;

    // Get current global page visit count from cookie
    const uniquePageVisits = getUniqueVisitsFromCookie();
    const expirationDateMonth = 2592000;
    const emailSignupPageTrigger = _.get(
        store.getState(),
        'core.featureConfigs.lightboxAnonymousEmailSubscriptions.emailSignupPageTrigger',
        2
    );

    // If user has already opted in or out then no-op this method
    if (Cookies.getCookieByName(COOKIE_NAME_EMAIL_SIGNUP_MARKETING_OPTIN)) {
        return;
    }

    // If user is on a page visit past the first then run signup modal sagas
    // Set cookie to signify that the user has been promted to opt in
    // Delete counter cookie as the email signup should be last in line
    if ((uniquePageVisits === emailSignupPageTrigger && !interstitialDiffered)) {
        store.runSaga(emailSignupMarketingSaga);
        Cookies.setCookie(COOKIE_NAME_EMAIL_SIGNUP_MARKETING_OPTIN, true, expirationDateMonth);
        clearInterstitialDeferredCookie();
    }
}

export function afterConstruction(store) {
    const initialized = _.get(store.getState(), this.watch, false);
    this.onStateChange(store, this.watch, false, initialized);
}

/**
 * onStateChange for emailSignupMarketingComponent
 * if user is not logged in will start email signup logic chain
 * @param {object} store Redux store
 * @param {object} watchValue current watch value from store at watch location
 */
function onStateChange(store, watchValue, previous, current) {
    if (current === true && !isWebview()) {
        // If user isn't logged in and not currently on an excluded page then kick of
        // email signup logic chain
        if (store.getState().core.loggedIn || isExcludedEmailSignupRoute(store)) {
            return;
        }

        setEmailSignupMarketingCookie(store);
    }
}

/**
 * init for emailSignupMarketingComponent
 * @param {object} store Redux store
 * @param {object} overrides optional overrides object for initialization
 * @returns {object} result of generate method
 */
export function init(store, overrides = {}) {
    const config = {
        name: 'emailSignupMarketingComponent',
        watch: 'core.initialized',
        onStateChange: onStateChange,
        afterConstruction: afterConstruction
    };

    return generate(config, store, overrides);
}
